import { Box, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { capitalizeText } from "../../../lib/utils";
import {
  IFondo,
  IMateriale,
  IQualita,
  IStatoLavorazione,
} from "../../../models";
import { IFilterOption } from "../../../models/utlis";
import SelectMaterialeFilters from "./SelectMaterialeFiltersV2";
import SelectMaterialeGrid from "./SelectMaterialeGrid";

interface ISelectMaterialeProps {
  filteredMateriali: IQualita[];
  materiali: IQualita[];
  tipologie: IMateriale[];
  colori: IFondo[];
  lavorazioni: IStatoLavorazione[];
  spessoriDisponibili: number[];
  filters: IFilterOption[];
  onView: (materiale: IQualita) => void;
  onSetFilters: (filters: IFilterOption[]) => void;
}

export default function SelectMateriale({
  filteredMateriali,
  materiali,
  tipologie,
  colori,
  filters,
  lavorazioni,
  spessoriDisponibili,
  onView,
  onSetFilters,
}: ISelectMaterialeProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          px: "20px",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#36363d",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <Box>
          <Typography sx={{}} level="h2">
            {capitalizeText(t("Warehouse"))}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          px: "20px",
          display: "flex",
          alignItems: "center",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <SelectMaterialeFilters
          materiali={materiali}
          tipologie={tipologie}
          colori={colori}
          lavorazioni={lavorazioni}
          spessoriDisponibili={spessoriDisponibili}
          filters={filters}
          onSetFilters={onSetFilters}
        ></SelectMaterialeFilters>
      </Box>
      <Box sx={{ flex: 1, position: "relative" }}>
        <SelectMaterialeGrid materiali={filteredMateriali} onView={onView} />
      </Box>
    </Box>
  );
}
